import { Component, OnInit } from '@angular/core';
import { FormArray, ReactiveFormsModule, FormsModule, FormBuilder, Validators } from '@angular/forms';
import { UserService, OperationsService, AuthenticationService, StorageService } from '../../_services';
import {ToastrService} from 'ngx-toastr';
 

@Component({
  selector: 'app-financialposition',
  templateUrl: './financialposition.component.html',
  styleUrls: ['./financialposition.component.css']
})
export class FinancialpositionComponent implements OnInit {

  public currentUser: any;
  public loading = false;
  public filter = { token: '', DDATE: '', DDATE_: '', SHOW_ZERO_BALANCE: false, PLDDATE:'' }
  public data: any;
  date: any;

  constructor(public fb: FormBuilder, public operationsService: OperationsService, public storageService: StorageService, private toastr: ToastrService) {
    this.currentUser = this.storageService.read<any>('currentUser');
    this.filter.token = this.currentUser.token;
  }


  ngOnInit() {
    this.getBalanceSheet();
  }
  showError(msg) {
    return this.toastr.error(msg, 'Error');
  }
  getBalanceSheet() {
    this.loading = true;
    this.operationsService.getBalanceSheetStatement(this.currentUser.token, this.date).subscribe(data => {
      this.data = data;
      this.loading = false;
    }, () => {
      this.loading = false;
      this.showError('An error occurred, try again');
    });
  }
  downloadPdf() {
    
  }
}
